import { Component, OnInit, Input, Output, } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { TeemappService } from '@teem/services/teemapp.service';
import { LoaderService } from '@teem/services/loader.service';
import { UserService } from '@teem/services/user.service';
import { SUBSCRIPTION_STATUS } from '@teem/constants/subscription';
import { messages as i18n } from '@teem/constants/messages';
@Component({
	selector: 'subscription-plan',
	templateUrl: './subscription-plan.component.html',
	styleUrls: ['./subscription-plan.component.scss'],
	animations: [
		trigger('fadeInOut', [
		  state('void', style({ opacity: 0 })),
		  state('*', style({ opacity: 1 })),
		  transition(':enter', [animate('300ms ease-in')]),
		  transition(':leave', [animate('300ms ease-out')])
		])
	  ]
})

export class SubscriptionPlanComponent implements OnInit {
	planCurrency: string = "<img src='/images/icons/sar_symbol_black.svg' loading='lazy'>";//$localize`:@@currency.sar:SAR`;
	discountPer = 20;
	currentRoute: string = 'subscription-plan';
	userInfo: any = {};
	subscription: any;
	activePlan: any = null;
	currentTab: 'invoicing' | 'onlineStore' | 'onlineOrdering' | 'completeSolution' = 'invoicing';
	activeTab: 'yearly' | 'monthly' = 'yearly';
	isPopupVisible: boolean = false;
	locale: string = 'en';

	invoicingFeatures = [
		{ name: i18n.plan.invoicing.ksa_vat_compliant_invoices, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.unlimited_clients, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.quotes_and_estimates, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.invoice_via_email, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.invoice_via_whatsapp, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.multiple_billing_addresses, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.multiple_bank_accounts, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.accept_online_payments, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.bill_in_any_currency, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.expense_management, basic: true, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.branding, basic: false, pro: false, enterprise: true },
		{ name: i18n.plan.invoicing.itemized_invoices, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.b2b_invoices, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.client_reports, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.sales_reports, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.invoicing.recurring_invoices, basic: false, pro: false, enterprise: true },
		{ name: i18n.plan.invoicing.payment_reminders, basic: false, pro: false, enterprise: true },
	];

	completeSolutionFeatures = [
		{ name: i18n.plan.complete_solution.dedicated_storefront, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.unlimited_product_listings, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.unlimited_orders, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.no_selling_fees, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.all_product_types, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.accept_online_payments, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.pick_up_orders, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.order_management, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.order_approval_option, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.inventory_management, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.foodics_sync, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.vat_collection, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.all_delivery_partners, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.all_payment_partners, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.custom_delivery_option, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.instant_checkout, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.promo_codes, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.delivery_discounts, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.sales_reports_and_analytics, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.custom_domain, basic: false, pro: true, enterprise: true },
		{ name: i18n.plan.complete_solution.custom_store_design, basic: false, pro: false, enterprise: true },
		{ name: i18n.plan.complete_solution.multiple_stores, basic: false, pro: false, enterprise: true },
	];

	otherFeatures = [
		{ name: i18n.plan.other.premium_support, basic: false, pro: false, enterprise: true }
	];

	plans: any = {
		'yearly': {
			'invoice-basic': { 'amount': 0 },
			'invoice-pro': { 'amount': 0 },
			'invoice-enterprise': { 'amount': 0 },
			'online-store-basic': { 'amount': 0 },
			'online-store-pro': { 'amount': 0 },
			'online-store-enterprise': { 'amount': 0 },
			'online-ordering-basic': { 'amount': 0 },
			'online-ordering-pro': { 'amount': 0 },
			'online-ordering-enterprise': { 'amount': 0 },
			'complete-solution': { 'amount': 0 },
		},
		'monthly': {
			'invoice-basic': { 'amount': 0 },
			'invoice-pro': { 'amount': 0 },
			'invoice-enterprise': { 'amount': 0 },
			'online-store-basic': { 'amount': 0 },
			'online-store-pro': { 'amount': 0 },
			'online-store-enterprise': { 'amount': 0 },
			'online-ordering-basic': { 'amount': 0 },
			'online-ordering-pro': { 'amount': 0 },
			'online-ordering-enterprise': { 'amount': 0 },
			'complete-solution': { 'amount': 0 },
		}
	};

	tempPlans: any = this.plans;

	constructor(
		private router: Router,
		private teemappService: TeemappService,
		private loaderService: LoaderService,
		private userService: UserService,
	) { }

	ngOnInit(): void {
		this.locale = (window as any).LOCALE;
		this.fetchUserInfo();
		this.fetchPlans();

		this.currentRoute = this.router.url;
	}

	switchTab(tab: 'invoicing' | 'onlineStore' | 'onlineOrdering' | 'completeSolution'): void {
		this.currentTab = tab;
	}

	get tabIndicatorPosition(): string {
		switch (this.currentTab) {
			case 'invoicing':
				// return '0%';
				return this.locale == 'en' ? '0%' : '66.66%';
			case 'onlineStore':
				return '33.33%';
			case 'onlineOrdering':
				return '33.33%';
			case 'completeSolution':
				// return '66.66%';
				return this.locale == 'en' ? '66.66%' : '0%';
			default:
				return '0%';
		}
	}

	tabChange(tab: 'yearly' | 'monthly') {
		this.activeTab = tab;
	}

	subscriptionBtn(planFrequency, planName) {
		let selectedPlanAmount = this.plans?.[planFrequency][planName]?.amount;
		let activePlanAmount = 0;
		if (this.activePlan?.plan_frequency) {
			activePlanAmount = this.plans?.[this.activePlan?.plan_frequency][this.activePlan?.subscription_plan]?.amount;
		}
		let priceDifference = (selectedPlanAmount ?? 0) - (activePlanAmount ?? 0);

		return (priceDifference > 0) ? 'upgrade' : ((priceDifference < 0) ? 'downgrade' : 'recurring');
	}

	planTabName(planName: string) {
		if (['invoice-basic','invoice-pro','invoice-enterprise'].includes(planName)) {
			return "invoicing";
		} else if (['online-store-basic','online-store-pro','online-store-enterprise'].includes(planName)) {
			return "onlineStore";
		} else if (['online-ordering-basic','online-ordering-pro','online-ordering-enterprise'].includes(planName)) {
			return "onlineOrdering";
		} else if(['complete-solution'].includes(planName)) {
			return "completeSolution";
		}
		return "invoicing";
	}

	fetchUserInfo() {
		this.loaderService.startLoading();
		this.userService.getUser().subscribe(data => {
			this.userInfo = data;
			this.subscription = this.userInfo ? this.userInfo.subscription : null;
			if (this.subscription) {
				this.activePlan = this.subscription;

				if (this.activePlan.subscription_status == SUBSCRIPTION_STATUS.free && this.activePlan.pending_request) {
					setTimeout(() => {
						this.activeTab = this.activePlan.pending_request.plan_frequency;
						this.currentTab = this.planTabName(this.activePlan.pending_request.subscription_plan);
					}, 10);
				} else {
					if (this.activePlan.plan_frequency && this.activePlan.subscription_plan) {
						setTimeout(() => {
							this.activeTab = this.activePlan.plan_frequency;
							this.currentTab = this.planTabName(this.activePlan.subscription_plan);
						}, 10);
					}
				}
			}
			this.loaderService.stopLoading();
		}, err => {
			this.loaderService.stopLoading();
		});
  	}

	fetchPlans() {
		this.teemappService.getPlans().subscribe((data: any) => {
			this.plans = data;
			if (data && data.plans) {
				this.plans.yearly = {
					'invoice-basic': { 'amount': data.plans.yearly?.['invoice-basic'] },
					'invoice-pro': { 'amount': data.plans.yearly?.['invoice-pro'] },
					'invoice-enterprise': { 'amount': data.plans.yearly?.['invoice-enterprise'] },
					'online-store-basic': { 'amount': data.plans.yearly?.['online-store-basic'] },
					'online-store-pro': { 'amount': data.plans.yearly?.['online-store-pro'] },
					'online-store-enterprise': { 'amount': data.plans.yearly?.['online-store-enterprise'] },
					'online-ordering-basic': { 'amount': data.plans.yearly?.['online-ordering-basic'] },
					'online-ordering-pro': { 'amount': data.plans.yearly?.['online-ordering-pro'] },
					'online-ordering-enterprise': { 'amount': data.plans.yearly?.['online-ordering-enterprise'] },
					'complete-solution': { 'amount': data.plans.yearly?.['complete-solution'] },
				};

				this.plans.monthly = {
					'invoice-basic': { 'amount': data.plans.monthly?.['invoice-basic'] },
					'invoice-pro': { 'amount': data.plans.monthly?.['invoice-pro'] },
					'invoice-enterprise': { 'amount': data.plans.monthly?.['invoice-enterprise'] },
					'online-store-basic': { 'amount': data.plans.monthly?.['online-store-basic'] },
					'online-store-pro': { 'amount': data.plans.monthly?.['online-store-pro'] },
					'online-store-enterprise': { 'amount': data.plans.monthly?.['online-store-enterprise'] },
					'online-ordering-basic': { 'amount': data.plans.monthly?.['online-ordering-basic'] },
					'online-ordering-pro': { 'amount': data.plans.monthly?.['online-ordering-pro'] },
					'online-ordering-enterprise': { 'amount': data.plans.monthly?.['online-ordering-enterprise'] },
					'complete-solution': { 'amount': data.plans.monthly?.['complete-solution'] },
				};
			}

			if (data && data.tempPlans) {
				this.tempPlans.yearly = {
					'invoice-basic': { 'amount': data.tempPlans.yearly?.['invoice-basic'] },
					'invoice-pro': { 'amount': data.tempPlans.yearly?.['invoice-pro'] },
					'invoice-enterprise': { 'amount': data.tempPlans.yearly?.['invoice-enterprise'] },
					'online-store-basic': { 'amount': data.tempPlans.yearly?.['online-store-basic'] },
					'online-store-pro': { 'amount': data.tempPlans.yearly?.['online-store-pro'] },
					'online-store-enterprise': { 'amount': data.tempPlans.yearly?.['online-store-enterprise'] },
					'online-ordering-basic': { 'amount': data.tempPlans.yearly?.['online-ordering-basic'] },
					'online-ordering-pro': { 'amount': data.tempPlans.yearly?.['online-ordering-pro'] },
					'online-ordering-enterprise': { 'amount': data.tempPlans.yearly?.['online-ordering-enterprise'] },
					'complete-solution': { 'amount': data.tempPlans.yearly?.['complete-solution'] },
				};

				this.tempPlans.monthly = {
					'invoice-basic': { 'amount': data.tempPlans.monthly?.['invoice-basic'] },
					'invoice-pro': { 'amount': data.tempPlans.monthly?.['invoice-pro'] },
					'invoice-enterprise': { 'amount': data.tempPlans.monthly?.['invoice-enterprise'] },
					'online-store-basic': { 'amount': data.tempPlans.monthly?.['online-store-basic'] },
					'online-store-pro': { 'amount': data.tempPlans.monthly?.['online-store-pro'] },
					'online-store-enterprise': { 'amount': data.tempPlans.monthly?.['online-store-enterprise'] },
					'online-ordering-basic': { 'amount': data.tempPlans.monthly?.['online-ordering-basic'] },
					'online-ordering-pro': { 'amount': data.tempPlans.monthly?.['online-ordering-pro'] },
					'online-ordering-enterprise': { 'amount': data.tempPlans.monthly?.['online-ordering-enterprise'] },
					'complete-solution': { 'amount': data.tempPlans.monthly?.['complete-solution'] },
				};
			}
		});
	}

	discountedPlanAmount(planAmount) {
		let amount = planAmount - (planAmount * (this.discountPer / 100));
		return amount.toFixed(2);
	}

	onSubscribePlan(fd: any) {
    	window.location.reload()
  	}

	planNameAsPerVersion(planName: string) {
		if (planName == "invoicing") {
			return i18n.subscription.invoicing;
		} else if (planName == "onlineStore") {
			return i18n.subscription.online_store;
		} else if (planName == "onlineOrdering") {
			return i18n.subscription.online_ordering;
		} else if (planName == "completeSolution") {
			return i18n.subscription.complete_solution;
		}
	}

	openPopup(): void {
		this.isPopupVisible = true;
	}

	closePopup(): void {
		this.isPopupVisible = false;
	}

}
